
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[country]/all-wikifolios/search",
      function () {
        return require("private-next-pages/[language]/[country]/all-wikifolios/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[country]/all-wikifolios/search"])
      });
    }
  